// src/pages/AddInterviewTopic.jsx
import React, { useState } from "react";
import { db } from "./firebase/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 40px;
  color: #fff;
  max-width: 500px;
  margin: auto;
`;

const Title = styled.h2`
  margin-bottom: 20px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: none;
  margin-bottom: 20px;
  font-size: 16px;
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #00d4ff, #00bcd4);
  color: #121212;
  font-weight: bold;
  cursor: pointer;
`;

const AddInterviewTopic = () => {
  const { prepId, moduleId } = useParams(); // ✅ added moduleId
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAddTopic = async () => {
    if (!title.trim()) {
      alert("Please enter topic title");
      return;
    }

    setLoading(true);

    try {
      await addDoc(
        collection(
          db,
          `interviewPreps/${prepId}/modules/${moduleId}/topics` // ✅ updated path
        ),
        {
          title,
          createdAt: serverTimestamp(),
        }
      );

      alert("✅ Topic created successfully");

      // ✅ go back to module detail page
      navigate(`/module-detail/${prepId}/${moduleId}`);
    } catch (error) {
      console.error("Error adding topic:", error);
      alert("❌ Failed to create topic");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <Title>➕ Add Topic</Title>

      <Input
        type="text"
        placeholder="Enter topic (e.g. React Hooks)"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <Button onClick={handleAddTopic} disabled={loading}>
        {loading ? "Creating..." : "Create Topic"}
      </Button>
    </Wrapper>
  );
};

export default AddInterviewTopic;
